<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
      >
        <v-icon>{{ mdiFileUploadOutline }}</v-icon>
        {{ $t('Outbox.UploadModifiedDoc') }}
      </v-btn>
    </template>
    <v-card>
      <v-container class="py-4">
        <h3 class="text-h6">
          {{ $t('Outbox.Oficio') }}
        </h3>
        <s-file-uploader-with-entity
          v-show="!isGenerating"
          ref="oficioUploader"
          :post-url="uploadFileUrl"
          :extensions="isESign?'pdf,doc,docx':'doc,docx'"
          :accept="isESign?'.pdf,.doc,.docx':'.doc,.docx'"
          :maximum="1"
          :filename.sync="oficioFilename"
          :response.sync="oficioDocResponse"
          :label="$t('Outbox.UploadOficio')"
          @uploadError="onUploadError"
        />
        <v-row
          v-show="isGenerating"
          class="fill-height"
          align-content="center"
          justify="center"
        >
          <v-col
            class="text-center"
            cols="12"
          >
            {{ $t('Outbox.GeneratingUploadFile') }}
          </v-col>
          <v-col cols="12">
            <v-progress-linear
              color="light-blue"
              indeterminate
              rounded
              height="20"
              striped
            />
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <span
          class="red--text"
          style="margin-right: 10px"
        >({{ $t('Outbox.Confirm.ModifiedDoc.Notice') }}) </span>
        <v-btn
          color="primary"
          :disabled="oficioDocResponse.length === 0"
          :loading="isGenerating"
          @click="confirmModify"
        >
          {{ $t('Outbox.Confirm.ModifiedDoc') }}
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="dialog = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SFileUploaderWithEntity from '@/components/SFileUploaderWithEntity'
import outboxApi from '@/api/outbox/outbox'
import { globalModule } from '@/store/moduleName'
import { filename, fileExt } from '@/utils/stringUtil'
import { uploadMethod } from '@/mixins/uploadMethod'
import { taskMethod } from '@/mixins/taskMethod'
import { mdiFileUploadOutline } from '@mdi/js'
import { outboxBasic } from '@/views/Tasklist/mixins/outboxBasicMixin'
import pdfApi from '@/api/tools/pdf'

export default {
  components: {
    SFileUploaderWithEntity
  },
  mixins: [uploadMethod, taskMethod, outboxBasic],
  props: {
    task: {
      type: Object,
      default: null
    },
    // groupId: {
    //   type: String,
    //   default: null
    // },
    businessCode: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      mdiFileUploadOutline: mdiFileUploadOutline,
      oficioFilename: null,
      oficioDocResponse: [],
      oficioPdfResponse: [],
      dialog: false,
      isGenerating: false,
      taskProp: this.genTaskProp(this.task)
    }
  },
  computed: {
    uploadFileUrl () {
      if (this.isESign) {
        return this.$config.apiDomain.ALI + `/ext/ga/core-util-outbox/outbox/api/uploadSignFile?entityId=${this.taskProp.issueEntityId}&entitySourceTypeId=1`
      } else {
        return this.$config.apiDomain.ALI + `/ext/ga/core-util-outbox/outbox/api/uploadWordFile?entityId=${this.taskProp.issueEntityId}&entitySourceTypeId=1`
      }
    }
  },
  methods: {
    confirmModify () {
      if (fileExt(this.oficioFilename).toLowerCase() === 'pdf') {
        this.checkPDF()
      } else {
        this.genPDF()
      }
    },
    checkPDF () {
      this.isGenerating = true
      pdfApi.checkSignatureFieldExists(this.oficioDocResponse[0].response.instanceCode, 'signature-1', resp => {
        if (resp.status === 201 || resp.status === 200) {
          if (resp.data) {
            this.oficioPdfResponse = []
            let pdfResp = {
              id: this.oficioDocResponse[0].response.id,
              instanceCode: this.oficioDocResponse[0].response.instanceCode,
              entityId: 0
            }
            this.oficioPdfResponse.push(pdfResp)
            this.updateOficioDocuments()
          } else {
            this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Outbox.Error.DocNoSignField'))
            this.stopGen()
          }
        } else {
          this.stopGen()
        }
      })
    },
    genPDF () {
      this.isGenerating = true
      let oficioId = this.task.formAttribute.formIdentity
      let instanceCode = this.oficioDocResponse[0].response.instanceCode
      let uploadFileId = this.oficioDocResponse[0].response.id
      outboxApi.mailMergeOficioPDFByOficioId(oficioId, instanceCode, uploadFileId, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.oficioPdfResponse = resp.data
          this.updateOficioDocuments()
        } else {
          this.stopGen()
        }
      })
    },
    stopGen () {
      this.isGenerating = false
    },
    clearAndclose () {
      this.isGenerating = false
      this.$refs.oficioUploader.clearFile()
      this.oficioDocResponse = []
      this.oficioPdfResponse = []
      this.dialog = false
    },
    updateOficioDocuments () {
      let oficios = []
      let oficioDocFilename = filename(this.oficioDocResponse[0].name)
      for (let i = 0; i < this.oficioPdfResponse.length; i++) {
        const e = this.oficioPdfResponse[i]
        oficios.push({
          displayName: oficioDocFilename,
          entityId: e.entityId,
          entitySourceTypeId: 1,
          fileExtension: 'pdf',
          instanceCode: e.instanceCode,
          uploadFileId: e.id
        })
      }
      let body = {
        formAttributeId: this.task.formAttribute.id,
        oficioDocDisplayName: filename(this.oficioDocResponse[0].name),
        oficioDocFileExtension: fileExt(this.oficioDocResponse[0].name),
        oficioDocInstanceCode: this.oficioDocResponse[0].response.instanceCode,
        oficioDocUploadFileId: this.oficioDocResponse[0].response.id,
        oficioId: this.task.formAttribute.formIdentity,
        oficios: oficios,
        workItemId: this.task.id
      }
      outboxApi.updateOficioDocuments(body, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Outbox.RenewOficio.Success'))
          this.clearAndclose()
          this.$emit('updateSuccess')
          // let promise = null
          // if (this.groupId) {
          //   promise = this.$store.dispatch(workflowModule + '/getGroupItems', { businessCode: this.businessCode, groupId: this.groupId })
          // } else {
          //   promise = this.$store.dispatch(workflowModule + '/getActiveItems', this.businessCode)
          // }
          // promise.then(
          //   response => {
          //     this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Outbox.RenewOficio.Success'))
          //     this.clearAndclose()
          //   }
          // ).catch(error => {
          //   console.log(error)
          //   this.stopGen()
          // })
        } else {
          this.stopGen()
        }
      })
    }
  }
}
</script>
